import type { HTMLAttributes } from 'react';

import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { Fragment } from 'react';

import { EditorSection } from './editor-section';

import styles from './ai-subtitles-editor-info.module.css';

type Stream = {
  language?: string | null;
  aiLiveTranscriptEditorSettings?: {
    primary?: { editorUrl: string; accessPin: string } | null;
    backup?: { editorUrl: string; accessPin: string } | null;
  } | null;
};

type Props = {
  streams?: Stream[];
} & HTMLAttributes<HTMLDivElement>;

export function AiSubtitlesEditorInfo({ streams, ...props }: Props) {
  if (!streams || streams.length === 0) return null;

  return (
    <div {...props} className={classNames(styles.wrapper, props.className)}>
      {streams.map((stream) => (
        <Fragment key={stream.language}>
          <EditorSection
            label="primary"
            language={stream.language}
            editorUrl={stream.aiLiveTranscriptEditorSettings?.primary?.editorUrl}
            accessPin={stream.aiLiveTranscriptEditorSettings?.primary?.accessPin}
          />

          <EditorSection
            label="backup"
            language={stream.language}
            editorUrl={stream.aiLiveTranscriptEditorSettings?.backup?.editorUrl}
            accessPin={stream.aiLiveTranscriptEditorSettings?.backup?.accessPin}
          />
        </Fragment>
      ))}
    </div>
  );
}
